import { useQuery } from '@tanstack/react-query';
import {
    fetchParentHistory,
    parentHistoryKeys,
    PARENT_HISTORY_STALE_TIME,
} from '../api/parentHistory';

export { parentHistoryKeys, PARENT_HISTORY_STALE_TIME };

/**
 * React Query hook for /parent/get-parent-history (via reenrolment backend)
 */
export const useParentHistory = (parentCode, options = {}) => {
    return useQuery({
        queryKey: parentHistoryKeys.byParentCode(parentCode),
        queryFn: () => fetchParentHistory(parentCode),
        enabled: Boolean(parentCode) && options.enabled !== false,
        staleTime: PARENT_HISTORY_STALE_TIME,
        refetchOnMount: false,
        retry: 1,
        ...options,
    });
};

export default useParentHistory;
